import React from 'react';
import moment from 'moment';
import { useTheme } from '../../../../theme-context';

const ReconciliationTable = ({
    rows,
    columns,
    paginationData,
    paginationState,
    setPaginationState,
}: {
    rows?: any;
    columns?: any;
    paginationData?: any;
    paginationState?: any;
    setPaginationState?: any
}) => {
    const { theme } = useTheme();

    const formatStatus = (status: string) => {
        if (status === 'Active') {
            return <div className="flex items-center px-3 py-1 bg-bgColor-darkMode rounded-lg justify-center">
                <p className='text-white font-normal text-nowrap'>{status}</p>
            </div>
        }
        if (status === 'Inactive') {
            return <div className="flex items-center px-3 py-1 bg-[#F5F5F5] rounded-lg justify-center">
                <p className='text-[#252B37] font-normal text-nowrap'>{status}</p>
            </div>
        }
    }

    return (
        <div className=''>
            <div className='overflow-x-auto border border-1 !rounded-xl dark:border-borderColor-darkMode'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-dark'>
                    <thead className='bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-primary-dark rounded-xl'>
                        <tr>
                            <th className='px-4 py-3'>Template Name</th>
                            <th className='px-4 py-3'>Last Modified</th>
                            <th className='px-4 py-3'>File Size</th>
                            <th className='px-4 py-3'>Created By</th>
                            <th className='px-4 py-3'>Status</th>
                            <th className='px-4 py-3'>Created At</th>
                            <th className='px-4 py-3'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row: any) => (
                            <tr key={row.id} className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                <td className={`px-4 py-4`}>{row?.fileName}</td>
                                <td className={`px-4 py-4`}>{moment(row?.updatedAt).format('DD-MM-YYYY, hh:mm A')}</td>
                                <td className={`px-4 py-4`}>{row?.fileSize || ''}</td>
                                <td className={`px-4 py-4`}>{row?.createdBy?.name || row?.createdBy?.email}</td>
                                <td className={`px-4 py-4`}>{formatStatus(row?.status)}</td>
                                <td className={`px-4 py-4`}>{moment(row?.createdAt).format('DD-MM-YYYY, hh:mm A')}</td>
                                <td className={`px-4 py-4`}>
                                    <div className='cursor-pointer hover:opacity-80' onClick={() => window.open(row?.url, '_blank')}>
                                        <img src={theme === 'dark' ? '/assets/admin-tab/download-white.svg' : '/assets/admin-tab/download.svg'} className='object-contain w-[23px]' />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {paginationData &&
                <div className='flex justify-between items-center bg-[#F0F0F0] dark:bg-[#3a3a3a] text-sm text-[#8F8F8F] dark:text-primary-dark px-5 py-2 mt-1 border-t border-[#DCDCDD]'>
                    <div>
                        {(paginationData && paginationData?.totalElements > 0) && (
                            <span>
                                {1 + ((paginationData?.number - 1) * paginationData?.size)}–
                                {Math.min(paginationData?.number * paginationData?.size, paginationData?.totalElements)} of {paginationData?.totalElements} items
                            </span>
                        )}
                    </div>
                    <div className='flex gap-2 items-center'>
                        <button
                            disabled={paginationData && paginationData?.number <= 1}
                            onClick={() =>
                                setPaginationState?.({
                                    ...paginationState,
                                    pageNumber: paginationData ? paginationData.number - 1 : 1,
                                })
                            }
                            className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                        >
                            ◀
                        </button>
                        <span>
                            Page {paginationData ? paginationData.number : 0} of {paginationData ? paginationData?.totalPages : 0}
                        </span>
                        <button
                            disabled={!paginationData?.hasNextPage}
                            onClick={() =>
                                setPaginationState?.({
                                    ...paginationState,
                                    pageNumber: paginationData ? paginationData.number + 1 : 1,
                                })
                            }
                            className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                        >
                            ▶
                        </button>
                    </div>
                </div>
            }
        </div>
    );
};

export default ReconciliationTable;
